import React, { useEffect } from "react";
import clsx from "clsx";
import styles from "./styles.module.css";
import { useTranslation } from "react-i18next";
import Header from "../../components/Header";
import PromotionBanner from "../../components/PromotionBanner";
import ImageComponent from "../../components/ImageComponent";
import noTournamentIcon from "../../assets/no-tournaments-available.svg";
import { _isEmpty } from "../../utils/helpers/zupeeLodash";
import Skeleton from "../../components/Skeleton";
import { useConfigStore } from "../../storage/configState";
import {FbPixelEvent_PageView } from "../../utils/FbPixel/fbPixel";
import { getPartnerId } from "../../utils/helpers/common";
import { FACEBOOK } from "../../utils/helpers/constants";


const Download: React.FC = () => {

  const { t } = useTranslation();
  const {downloadScreenData} = useConfigStore.getState()?.homeScreenConfig || {};
  const bannerPath = downloadScreenData?.banner?.imageUrl || "";
  const bannerText = downloadScreenData?.banner?.bannerText || "";
  const ctaLink = downloadScreenData?.banner?.cta || {};
  const hasTrackedRef = React.useRef(false);
  
  useEffect(() => {
    if (getPartnerId() === FACEBOOK && !hasTrackedRef.current) {
      hasTrackedRef.current = true;
      FbPixelEvent_PageView();
    }
  }, []);

  return (
    <>
     
      <div className={clsx(styles.pageWrapper, "pageWrapper")}>
        <Header pageTitle={t("download")} />
        {false ? (
          <Skeleton variant="card" />
        ) : (
          <>
            {!_isEmpty(bannerPath) ? (
                <PromotionBanner imageUrl={bannerPath} cta={ctaLink} bannerText={bannerText} />
            ) : (
              <div className={clsx(styles.emptyStateBox, "textAlignCenter")}>
                <ImageComponent
                  src={noTournamentIcon}
                  alt="no tournament"
                  className={clsx(styles.noDownloadLinkFoundIcon)}
                  style={{ marginBottom: "20px" }}
                />
                <h4 className={clsx("textAlignCenter")}>
                  {t("noDownloadLinkFound")}
                </h4>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Download;
